var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ChipContainer } from '../styles';
var Chip = function (_a) {
    var selected = _a.selected, onClick = _a.onClick, key = _a.key, content = _a.content, noMargins = _a.noMargins, customMargins = _a.customMargins, inverted = _a.inverted, pointer = _a.pointer;
    return (_jsxs(ChipContainer, __assign({ onClick: onClick, selected: selected, noMargins: noMargins, customMargins: customMargins, inverted: inverted, pointer: pointer }, { children: [_jsx(_Fragment, { children: selected && _jsx(FontAwesomeIcon, { icon: faCheck, color: "#000", fixedWidth: true }) }), content] }), key));
};
export default Chip;
